'use client';

import { useSafeNavigation } from '@/hooks/useSafeNavigation';
import ServiceHeader from '@/components/layout/service/ServiceHeader';
import { UNITY_GUIDE_DATA } from '@/(routers)/(contentset)/hello-schoomy/unity-guide/components/data/UnityGuide';

export default function UnityGuideIndex() {
    const { safePush } = useSafeNavigation();

    return (
        <>
            <ServiceHeader title="HELLO SCHOOMY." />
            <div className="flex justify-center w-full py-2">
                <div className="flex flex-col justify-center items-start w-full md:w-[98%]">
                    <div className="flex flex-col justify-start items-center bg-color-white-base w-full pt-2 pb-4 section-4-b">
                        <ul className="w-full px-4">
                            {UNITY_GUIDE_DATA.map(({ contentsUuid, subTitle, title }) => {
                                return (
                                    <div
                                        key={contentsUuid}
                                        className="border-b cursor-pointer py-8"
                                        onClick={() => {
                                            safePush(`/hello-schoomy/unity-guide/s1/${contentsUuid}`);
                                        }}
                                    >
                                        <div className="font-corp font-bold text-xl text-color-base hover:underline underline-offset-2">
                                            {title}
                                        </div>
                                        <div className="section-spacer-inner-y"></div>
                                        <div className="font-notojp font-medium text-xs text-color-co-gray-dark">
                                            {subTitle}
                                        </div>
                                    </div>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}
